import { Helmet } from 'react-helmet'

const SeoLogin = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title + ' | Gemvision'}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <link rel='canonical' href='https://gemvision.com/login' />
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Log In to Your Gemvision Account",
            "description": "Sign in to your Gemvision account to manage your licenses, access design tools, and view software updates.",
            "item": "https://gemvision.com/login"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default SeoLogin
